'use client';

import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';
import { useBuildActiveFilters } from './useBuildActiveFilters';

import { ActiveFilterButton } from '@/components/ActiveFilterButton/ActiveFilterButton';
import { ButtonMinimal } from '@/components/ButtonMinimal';
import { type ActiveFilter } from '@/modules/filters/types';
import { useSearchFilters } from '@/modules/search/useSearchFilters';

type Props = {
  className?: string;
  onClearAllClick?: () => void;
};

export function ActiveFilters({ className, onClearAllClick }: Props) {
  const t = useTranslations('search');
  const {
    setSearchFilters: { clearAll },
  } = useSearchFilters();
  const activeFilters = useBuildActiveFilters();

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <div className={clsx(styles.activeFiltersContainer, className)}>
      {activeFilters.map((activeFilter: ActiveFilter) => (
        <ActiveFilterButton key={activeFilter.name} {...activeFilter} />
      ))}
      <ButtonMinimal
        className={styles.resetAllButton}
        onClick={onClearAllClick || clearAll}
      >
        <Caption as="span" variant="lg-regular">
          {t('ResetAll')}
        </Caption>
      </ButtonMinimal>
    </div>
  );
}
